import { ArrowRight, MapPin } from "lucide-react";

const HERO_VIDEO = "/media/buildday-hero.mp4";
const HERO_POSTER = "/media/buildday-poster.jpg";

const SOCIAL_PROOF = [
  "In-Person Transformation",
  "Hosted At FMF Studio",
  "Strategy · Content · Networking",
  "Real Founder Mentorship",
];

export const BuildDayHero = () => {
  return (
    <section
      id="top"
      data-testid="buildday-hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden bg-[#0A0A0C]"
    >
      <div className="absolute inset-0 z-0">
        <video
          data-testid="buildday-hero-video"
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster={HERO_POSTER}
        >
          <source src={HERO_VIDEO} type="video/mp4" />
        </video>
        {/* Lighter overlays so the footage breathes */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-[#0A0A0C]" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/10 to-black/40" />
        <div className="absolute inset-0 grain" />
        {/* warmer blue glow */}
        <div
          aria-hidden="true"
          className="absolute -left-32 top-1/3 w-[480px] h-[480px] rounded-full opacity-40 blur-3xl"
          style={{ background: "radial-gradient(circle, #4F7CFF 0%, transparent 70%)" }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 min-h-[100svh] flex flex-col justify-end pb-16 md:pb-24 pt-32">
        <div className="max-w-4xl">
          <div className="reveal flex items-center gap-3 mb-8">
            <span className="inline-flex items-center gap-2 border border-[#4F7CFF]/50 bg-[#4F7CFF]/15 px-3 py-1.5">
              <span className="w-1.5 h-1.5 bg-[#FCD34D] animate-pulse" />
              <span className="text-[10px] tracking-[0.3em] uppercase text-white font-bold">
                One-Day Transformation · London
              </span>
            </span>
          </div>

          <h1
            data-testid="buildday-hero-headline"
            className="reveal text-6xl sm:text-7xl lg:text-8xl xl:text-[8rem] leading-[0.9] tracking-tighter font-extrabold text-white"
          >
            The Builders
            <br />
            <span className="italic font-light text-white">
              Sprint<span className="text-[#FCD34D]">.</span>
            </span>
          </h1>

          <p
            data-testid="buildday-hero-subheadline"
            className="reveal mt-8 max-w-2xl text-base md:text-lg lg:text-xl leading-relaxed text-zinc-200 font-medium"
          >
            One day. One room. Real transformation. A high-energy in-person
            experience built to give ambitious people the clarity, content and
            momentum to finally move properly.
          </p>

          <div className="reveal mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="#apply-buildday"
              data-testid="buildday-hero-apply-btn"
              className="group inline-flex items-center justify-center gap-3 bg-white text-black font-bold text-sm tracking-[0.15em] uppercase px-7 py-4 hover:bg-zinc-200 transition-colors duration-300"
            >
              Reserve Your Spot
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <div
              data-testid="buildday-hero-spaces"
              className="group inline-flex items-center justify-center gap-3 bg-transparent text-white font-semibold text-sm tracking-[0.15em] uppercase px-7 py-4 border border-zinc-600"
            >
              <span className="w-2 h-2 bg-[#FCD34D] animate-pulse" />
              Limited Spaces Available
            </div>
          </div>

          {/* Subtle social proof row */}
          <div className="reveal mt-14 border-t border-zinc-700/70 pt-6 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {SOCIAL_PROOF.map((item, i) => (
              <div
                key={i}
                className="flex items-start gap-2.5 text-zinc-300"
              >
                <span className="mt-1.5 w-1 h-1 bg-[#4F7CFF] flex-shrink-0" />
                <span className="text-xs md:text-[13px] tracking-[0.12em] uppercase font-semibold leading-snug">
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-6 md:right-12 z-10 hidden md:flex items-center gap-3 text-zinc-400">
        <MapPin className="w-3.5 h-3.5" />
        <span className="text-[10px] tracking-[0.3em] uppercase">FMF Studio</span>
        <span className="h-8 w-px bg-zinc-600" />
      </div>
    </section>
  );
};
